import { ProductVideosTab } from './ProductVideosTab';

export default ProductVideosTab;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVideosTab/index.ts